// src/views/pages/pos/widget/Offers.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import configFile from "./config"; // adjust path

const Offers = ({ config, orgId }) => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const apiURL = configFile.API_URL;

  const fetchOffers = async () => {
    if (!orgId) {
      console.warn("❌ No orgId provided to Offers component");
      setOffers([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.get(`${apiURL}/pos/myoffers/listings`, {
        params: { code: orgId },
      });
      setOffers(data || []);
    } catch (error) {
      console.error("Error fetching offers:", error);
      setOffers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, [orgId]);

  return (
    <div
      className="offers-container"
      style={{ fontFamily: config?.font || "Inter, sans-serif" }}
    >
      <h2 className="offers-heading">🎉 Current Offers</h2>

      {loading ? (
        <p>Loading offers...</p>
      ) : offers.length === 0 ? (
        <p className="no-offers">No active offers at the moment.</p>
      ) : (
        <div className="offers-grid">
          {offers.map((offer) => (
            <div key={offer.id} className="offer-card">
              <div
                className="offer-icon"
                style={{ backgroundColor: offer.color || "#3b82f6" }}
              >
                {offer.icon || "🎉"}
              </div>
              <div className="offer-content">
                <h3>{offer.title}</h3>
                <p>{offer.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      <style>{`
        .offers-container {
          padding: 24px;
        }

        /* Gradient heading */
        .offers-heading {
          font-size: 1.8rem;
          font-weight: 800;
          margin-bottom: 24px;
          text-align: center;
          background: linear-gradient(90deg, ${config?.colors?.primary ||
            "#3b82f6"}, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .offers-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
        }

        @media (min-width: 640px) {
          .offers-grid {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (min-width: 1024px) {
          .offers-grid {
            grid-template-columns: 1fr 1fr 1fr;
          }
        }

        .offer-card {
          display: flex;
          align-items: flex-start;
          background: rgba(255, 255, 255, 0.85);
          border-radius: 14px;
          padding: 18px;
          box-shadow: 0 4px 14px rgba(0,0,0,0.1);
          backdrop-filter: blur(6px);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          border-left: 6px solid ${config?.colors?.primary || "#3b82f6"};
        }

        .offer-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        }

        .offer-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: #fff;
          margin-right: 14px;
          flex-shrink: 0;
          box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        }

        .offer-content h3 {
          font-size: 1.1rem;
          font-weight: 700;
          margin: 0 0 6px;
          color: #111827;
        }

        .offer-content p {
          font-size: 0.95rem;
          color: #4b5563;
          margin: 0;
          line-height: 1.4;
        }

        .no-offers {
          color: #6b7280;
          font-size: 1rem;
          text-align: center;
          padding: 40px 0;
        }
      `}</style>
    </div>
  );
};

export default Offers;
